<div class="audit-stats-industry-container">
  <report-loader></report-loader>
  <report-alert class="report-main-content-padding no-print"></report-alert>
  <h1 class="title pdf">
    Audit Statistics
  </h1>

  <div class="audit-stats-body">
    <div class="audit-stats-views">
      <div
        *ngFor="let state of auditStatsViews; let i = index"
        class="link-btn"
        [ngClass]="{ 'link-inactive': state.value !== currentView.value }"
        (click)="selectState(state)"
      >
        {{ state.name }}
        <span class="dash" *ngIf="i < auditStatsViews.length - 1">|</span>
      </div>
    </div>
  

    <!-- Input Form -->
    <div class="audit-stats-body-item audit-stats-form-container">
      <form class="audit-stats-input-form form-box grey-border-1" fxFlex="100" [formGroup]="auditSearchFormGroup">
        <!-- Periodicity -->
        <mat-form-field>
          <mat-label>Periodicity <span style="color: #D90E39;">*</span></mat-label>
          <mat-select formControlName="periodicity">
            <mat-option *ngFor="let period of periodicityOptions" [value]="period.value">
              {{ period.label }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="auditSearchFormGroup.controls.reports.hasError('required')">
            This field is required.
          </mat-error>
        </mat-form-field>

        <!-- Report -->
        <mat-form-field class="audit-stats-form-report-title-field">
          <mat-label>Report Title <span style="color: #D90E39;">*</span></mat-label>
          <mat-select [formControl]="auditSearchFormGroup.controls.reports" multiple>
            <mat-option
              *ngFor="let reportType of filteredReportTypesList"
              [value]="reportType.reportTypeName"
              [attr.title]="reportType.reportTypeName + ', ' + 'Active: ' + !reportType.reportDeleted"
            >
              {{ reportType.reportTypeName }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="auditSearchFormGroup.controls.reports.hasError('required')">
            This field is required.
          </mat-error>
        </mat-form-field>

        <!-- Start Date -->
        <finra-datepicker
          *ngIf="auditSearchFormGroup.controls.periodicity.value === 'daily'"
          [control]="auditSearchFormGroup.controls.startDate"
          [name]="'startDate'"
          [title]="'Start Date'"
        ></finra-datepicker>
        <mat-form-field *ngIf="auditSearchFormGroup.controls.periodicity.value === 'monthly'">
          <mat-select placeholder="Start Date" formControlName="startDate">
            <mat-option *ngFor="let date of formattedMonthlyDatesList" [value]="date.formattedDate">
              {{ date.formattedDate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="auditSearchFormGroup.controls.periodicity.value === 'quarterly'">
          <mat-select placeholder="Start Date" formControlName="startDate">
            <mat-option *ngFor="let date of quarterlyDatesList" [value]="date.formattedQuarter">
              {{ date.formattedQuarter }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- End Date -->
        <finra-datepicker
          *ngIf="auditSearchFormGroup.controls.periodicity.value === 'daily'"
          [control]="auditSearchFormGroup.controls.endDate"
          [name]="'endDate'"
          [title]="'End Date'"
        ></finra-datepicker>
        <mat-form-field *ngIf="auditSearchFormGroup.controls.periodicity.value === 'monthly'">
          <mat-select placeholder="End Date" formControlName="endDate">
            <mat-option *ngFor="let date of formattedMonthlyDatesList" [value]="date.formattedDate">
              {{ date.formattedDate }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="auditSearchFormGroup.controls.endDate.hasError('dateRangeInvalid')">
            End Date must be on or after Start Date.
          </mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="auditSearchFormGroup.controls.periodicity.value === 'quarterly'">
          <mat-select placeholder="End Date" formControlName="endDate">
            <mat-option *ngFor="let date of quarterlyDatesList" [value]="date.formattedQuarter">
              {{ date.formattedQuarter }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="auditSearchFormGroup.controls.endDate.hasError('dateRangeInvalid')">
            End Date must be on or after Start Date.
          </mat-error>
        </mat-form-field>

        <!-- Version -->
        <mat-form-field>
          <mat-select placeholder="Version" formControlName="version">
            <mat-option *ngFor="let version of versionsList" [value]="version">
              {{ version }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Firm ID -->
        <mat-form-field *ngIf="currentView.value === 'firm'">
          <input
            type="text"
            matInput
            placeholder="Firm ID"
            formControlName="firmId"
          />
        </mat-form-field>

        <button
          mat-flat-button
          color="accent"
          class="submit-button"
          [disabled]="auditSearchFormGroup.invalid"
          (click)="onSubmit()"
        >
          Submit
        </button>
      </form>
    </div>

    <!-- Export Button -->
    <div class="audit-stats-body-item audit-stats-export-container">
      <button
        mat-flat-button
        color="accent"
        class="export-button"
        [disabled]="!showGrid"
        [matTooltip]="!showGrid ? 'Please submit the form first to enable export.' : ''"
        matTooltipPosition="above"
        (click)="onExport()"
      >
        Export
      </button>
    </div>

    <!-- Grid -->
    <div class="audit-stats-body-item audit-stats-grid-container" *ngIf="showGrid">
      <report-finra-grid
        *ngIf="currentView.value === 'industry'"
        class="pdf"
        #reportfinragrid
        id="id"
        [groupDefaultExpanded]="0"
        [columnDefs]="industryColumnDefs"
        [rowData]="industryRowData"
        [autoResize]="false"
        [pageSize]="20"
        [wrapHeaderText]="true"
        [autoHeaderHeight]="true"
      ></report-finra-grid>

      <report-finra-grid
        *ngIf="currentView.value === 'firm'"
        class="pdf"
        #reportfinragrid
        id="id"
        [groupDefaultExpanded]="0"
        [columnDefs]="firmColumnDefs"
        [rowData]="firmRowData"
        [autoResize]="false"
        [pageSize]="20"
        [wrapHeaderText]="true"
        [autoHeaderHeight]="true"
      ></report-finra-grid>
    </div>
  </div>
</div>
